import React, { cloneElement, useState, useEffect, useCallback } from 'react';
import cn from 'classnames';

const GettingStartedTabs = ({
  items,
  selected: selectedTab,
  title,
  contentTitle,
  children,
  onChange,
}) => {
  const [selected, setSelected] = useState(selectedTab || 0);
  const component = children[selected];

  useEffect(
    () => {
      if (selectedTab && selectedTab !== selected) {
        setSelected(selectedTab);
      }
    },
    [selectedTab, selected],
  );

  const handleChange = useCallback(item => {
    setSelected(item);
    if (onChange) onChange(item);
  }, []);

  return (
    <div className="getting-started_tabs">
      {title && <div className="getting-started_tabs-title">{title}</div>}
      <div className="getting-started_tags">
        {items.map((item, index) => (
          <div
            key={index}
            className={cn('getting-started_tag', {
              '-active': selected === index,
            })}
            onClick={() => handleChange(index)}
          >
            {item.label}
            {item.selected && <span className="getting-started_tag-icon">✓</span>}
          </div>
        ))}
      </div>
      <div className="getting-started_tabs-content">
        {contentTitle && <div className="getting-started_tabs-title">{contentTitle}</div>}
        {component && cloneElement(component)}
      </div>
    </div>
  );
};

export default GettingStartedTabs;



// WEBPACK FOOTER //
// ./app/javascript/components/getting_started/components/GettingStartedTabs.js